export default __webpack_public_path__ + "f52b2e4188392ce6e2168ef83d6134f0.png";